<template>
  <router-view/>
</template>

<style>

@import url('https://fonts.googleapis.com/css2?family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap');

:root{
  --green-blnv: #004d27;
  --green-blna: #009944;
  --red-blna: #009944;
  --yellow-blna: #009944;
  --dark-blna:#2c3e50;
  --white-blnv: #fff;
  --weight-tittle-blnv: 500;
  --size-tittle-blnv: 1rem;
}

#app {
   /* font-family: Verdana, Geneva, Tahoma, sans-serif;  */
  /* font-family: 'Roboto', sans-serif; */
  /* font-family: "Homemade Apple"; */
  font-family: "Red Hat Display", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px;


  /* margin: 0;
  padding: 0;
  box-sizing: border-box; */
}
</style>
